<template>
  <v-sheet class="pa-4 h-100">
    <v-sheet outlined class="rounded overflow-hidden h-100 d-flex flex-column">
      <div
        class="pa-2 pb-0 d-flex align-center justify-space-between"
        style="gap: 8px"
        :class="{
          'flex-wrap': $vuetify.breakpoint.xs,
        }">
        <v-btn
          @click="$router.push({ name: 'contracts', params: { id: $route.params.id } })"
          icon
          class="mr-2"
          ><v-icon>mdi-arrow-left</v-icon></v-btn
        >
        <h3>Manage Projects</h3>
        <v-btn v-has="permissions.TaskBoardProjects.Create" @click="update()" small color="primary"
          ><v-icon left>mdi-plus</v-icon> Add Project</v-btn
        >

        <v-spacer v-if="!$vuetify.breakpoint.xs"></v-spacer>
        <v-sheet :width="$vuetify.breakpoint.xs ? '100%' : 250">
          <v-text-field
            hide-details
            outlined
            v-model="options.search"
            dense
            class="search-bar"
            placeholder="Search in projects..."
            clearable
            prepend-inner-icon="mdi-magnify"></v-text-field>
        </v-sheet>
      </div>

      <v-data-table
        class="elevation-0 pa-2 rounded-0 d-flex flex-column table-sticky custom-table"
        :footer-props="{
          showFirstLastPage: true,
          firstIcon: 'mdi-chevron-double-left',
          lastIcon: 'mdi-chevron-double-right',
          prevIcon: 'mdi-chevron-left',
          nextIcon: 'mdi-chevron-right',
          itemsPerPageText: 'Row/Page',
          itemsPerPageOptions: [15, 30, 50, 100, 200, 300, 400, 500, -1],
        }"
        :headers="projectHeaders"
        :items="entries"
        :options.sync="options"
        :loading="loading"
        :server-items-length="total">
        <template v-slot:[`item.startDate`]="{ item }">
          {{ $formatDate(item.startDate) }}
        </template>
        <template v-slot:[`item.finishDate`]="{ item }">
          {{ $formatDate(item.finishDate) }}
        </template>
        <template v-slot:[`item.projectManager`]="{ item }">
          <user-avatar
            v-if="item.projectManager"
            :user="item.projectManager"
            disable-open-link
            hide-roles
            show-no-user></user-avatar>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-menu dense offset-x right>
            <template v-slot:activator="{ attrs, on }">
              <v-btn icon elevation="0" v-bind="attrs" v-on="on">
                <v-icon size="16px">mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list class="more-options-menu" dense>
              <v-list-item
                 
                @click="update(item.id)"
                dense>
                <v-list-item-icon class="mr-2 justify-center">
                  <v-icon small>fa-solid fa-eye</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>View</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item :disabled="!$has(permissions.TaskBoardProjects.Delete)" @click="del(item.id)" dense>
                <v-list-item-icon class="mr-2 justify-center">
                  <v-icon small color="error">mdi-delete-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title> Delete</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>

        <template v-slot:no-data>
          <div class="text-center d-flex flex-column">
            <img width="300" src="/img/notFound.svg" class="py-5 my-8" style="opacity: 0.54" />
            <p class="font-weight-medium">No Data Available!</p>
          </div>
        </template>

        <template v-slot:loading>
          <div class="text-center d-flex flex-column">
            <img width="300" src="/img/loading.svg" class="py-5 my-8" style="opacity: 0.54" />
            <p class="font-weight-medium">Loading Projects...</p>
          </div>
        </template>
      </v-data-table>
      <EditProject ref="editProject"></EditProject>
    </v-sheet>
  </v-sheet>
</template>

<script>
  import UserAvatar from '@Share/components/UserAvatar.vue';
  import projectHeaders from '@Contract/config/project.headers';
  import { mapGetters } from 'vuex';
  import EditProject from '@Contract/components/EditProject.vue';
  import permissions from '@Share/config/permissions';
  import { $formatDate } from '@Utils';
import { $has } from '@/utils';

  export default {
    name: 'project-list',
    data() {
      return {
        projectHeaders,
        activeProjects: true,
        permissions,
        timerId: null,
      };
    },
    computed: {
      ...mapGetters('PROJECT', {
        loading: 'GET_LOADING',
        entries: 'GET_ENTRIES',
        total: 'GET_TOTAL',
      }),
      ...mapGetters('ACCOUNT', {
        company: 'GET_COMPANY',
      }),
      options: {
        get() {
          return this.$store.getters['PROJECT/GET_OPTIONS'];
        },
        set(val) {
          this.$store.commit('PROJECT/SET_OPTIONS', val);
        },
      },
    },
    methods: {
      $has,
      $formatDate,
      getDataDebounced() {
        if (this.timerId == null) {
          this.timerId = -1;
          this.options.contractId = this.$route.params.contractId;
          this.$store.dispatch('PROJECT/GET');
          return;
        }
        // cancel pending call
        clearTimeout(this.timerId);

        // delay new call 400ms
        this.timerId = setTimeout(() => {
          this.options.contractId = this.$route.params.contractId;
          this.$store.dispatch('PROJECT/GET');
        }, 400);
      },
      update(projectItemId = null) {
        this.$refs.editProject.open(projectItemId, true);
      },
      del(id) {
        this.$dialog.error({
          text: 'Are You Sure You Want to Delete This Project?',
          title: 'Delete Project',
          actions: {
            false: 'Cancel',
            true: {
              text: 'Ok',
              color: 'primary',
              handle: () => {
                return this.$store.dispatch('PROJECT/DELETE', id);
              },
            },
          },
        });
      },
    },
    watch: {
      options: {
        deep: true,
        handler() {
          this.getDataDebounced();
        },
      },
      $route: {
        handler() {
          this.options.contractId = this.$route.params.contractId;
        },
        deep: true,
      },
    },
    components: {
      UserAvatar,
      EditProject,
    },
    destroyed() {
      this.$store.commit('PROJECT/SET_ENTRIES', []);
    },
  };
</script>
